import Login from '../components/modules/auth/Login';
import GoogleLogin from '../components/modules/auth/GoogleLogin';
import SSOLogin from '../components/modules/auth/AzureLogin';
import Profile from '../components/modules/auth/Profile';
import PasswordReset from '../components/modules/auth/PasswordReset';

const auth = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login',
      filter: false,
      header: false,
    },
  },
  {
    path: '/login/google',
    name: 'GoogleLogin',
    component: GoogleLogin,
    meta: {
      filter: false,
      header: false,
    },
  },
  {
    path: '/login/azure',
    name: 'SSOLogin',
    component: SSOLogin,
    meta: {
      filter: false,
      header: false,
    },
  },
  {
    path: '/reset-password',
    name: 'PasswordReset',
    component: PasswordReset,
    meta: {
      filter: false,
      header: false,
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    requiresAuth: true,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Login,
    meta: {
      title: 'Logout',
      filter: false,
      header: false,
    },
  },
];

export default auth;
